module.exports = __webpack_public_path__ + "logo.40f3b36b.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/logo.svg
 ** module id = 347
 ** module chunks = 0
 **/